import { BaseContainerModel } from "../../base-container.model";
import { alg_bot_cf_message_link_RowClass } from "../../../dbschema";

export class BotCfMessageLinkContainerModel extends BaseContainerModel{
  alg_bot_cf_message_link: alg_bot_cf_message_link_RowClass = new alg_bot_cf_message_link_RowClass();
}
